import { render, staticRenderFns } from "./manage-bon-consultation.html?vue&type=template&id=552d8a47&scoped=true&external"
import script from "./manage-bon-consultation.js?vue&type=script&lang=js&external"
export * from "./manage-bon-consultation.js?vue&type=script&lang=js&external"
import style0 from "./manage-bon-consultation.scss?vue&type=style&index=0&id=552d8a47&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d8a47",
  null
  
)

export default component.exports